import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { environment } from '@environment/environment';

@Component({
	selector: 'app-final-step',
	templateUrl: './final-step.component.html',
	styleUrls: ['./final-step.component.css'],
})
export class FinalStepComponent implements OnInit {
	@Input() fileData: Array<string[]>;
	@Input() errorMsgs: Array<string> = [];
	@Output() uploadFileEvent: EventEmitter<null> = new EventEmitter();
	@Output() resetFileData: EventEmitter<any> = new EventEmitter();

	environment = environment;

	dataSource = new MatTableDataSource<any>([]);
	PREVIEW_TABLE_PAGE_SIZE = null;
	PREVIEW_TABLE_HEADERS: Array<string> = null;
	PREVIEW_TABLE_COLUMNS: Array<string> = null;
	DATA_TYPE: Array<string> = [];
	TABLE_ICONS = [];

	constructor() {}

	ngOnInit() {}

	ngOnChanges() {
		if (this.errorMsgs.length === 0 && this.fileData && this.fileData.length > 0) {
			this.PREVIEW_TABLE_HEADERS = this.fileData[0].map((header: string) =>
				header.toUpperCase().trim()
			);
			this.PREVIEW_TABLE_COLUMNS = [...this.PREVIEW_TABLE_HEADERS];
			const data = this.fileData.slice(1);
			let table: Array<any> = [];
			for (let dataCounter = 0; dataCounter < data.length; dataCounter++) {
				const valueRows = data[dataCounter];
				let rowObject = {};
				valueRows.map((value, valuIndex) => {
					rowObject[this.PREVIEW_TABLE_COLUMNS[valuIndex]] = value;
				});
				if (dataCounter < environment.RFP_PREVIEW_TABLE_ROWS_LIMIT) {
					table[dataCounter] = rowObject;
				} else {
					break;
				}
			}
			this.PREVIEW_TABLE_COLUMNS.map((_) => this.DATA_TYPE.push('string'));
			this.dataSource = new MatTableDataSource<any>(
				table.slice(0, environment.RFP_PREVIEW_TABLE_ROWS_LIMIT)
			);
			this.PREVIEW_TABLE_PAGE_SIZE = environment.RFP_PREVIEW_TABLE_ROWS_LIMIT;
		}
	}

	uploadFile() {
		this.uploadFileEvent.emit();
	}
}
